module.exports = __webpack_public_path__ + "static/img/wait.5a3e5308.svg";